export default {"src":"/_next/static/media/linkedin.e5ed203a.svg","height":17,"width":17,"blurWidth":0,"blurHeight":0};